import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Filter } from 'lucide-react';
import { CATEGORIES, PAYMENT_MODES, SUB_CAT_CATEGORIES, SUB_CAT_PLURAL } from '@/constants/categories';

export function EntriesFilters({ filters, setFilters, sites, subCategories }) {
  const filterSubCats = subCategories.filter(sc => filters.category ? sc.parent_category === filters.category : true);

  return (
    <div className="flex flex-wrap gap-2 items-center" data-testid="entries-filters">
      <Filter className="w-4 h-4 text-muted-foreground" />
      <Select value={filters.site_id} onValueChange={v => setFilters(f => ({ ...f, site_id: v === 'all' ? '' : v }))}>
        <SelectTrigger className="w-[160px] h-8 text-xs" data-testid="filter-site"><SelectValue placeholder="All Sites" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Sites</SelectItem>
          {sites.map(s => <SelectItem key={s._id} value={s._id}>{s.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={filters.entry_type} onValueChange={v => setFilters(f => ({ ...f, entry_type: v === 'all' ? '' : v }))}>
        <SelectTrigger className="w-[140px] h-8 text-xs" data-testid="filter-type"><SelectValue placeholder="All Types" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Types</SelectItem>
          <SelectItem value="income">Money In</SelectItem>
          <SelectItem value="expense">Money Out</SelectItem>
        </SelectContent>
      </Select>
      <Select value={filters.category} onValueChange={v => setFilters(f => ({ ...f, category: v === 'all' ? '' : v, sub_category: '' }))}>
        <SelectTrigger className="w-[160px] h-8 text-xs" data-testid="filter-category"><SelectValue placeholder="All Categories" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Categories</SelectItem>
          {CATEGORIES.map(c => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}
        </SelectContent>
      </Select>
      {filters.category && SUB_CAT_CATEGORIES.includes(filters.category) && (
        <Select value={filters.sub_category} onValueChange={v => setFilters(f => ({ ...f, sub_category: v === 'all' ? '' : v }))}>
          <SelectTrigger className="w-[160px] h-8 text-xs" data-testid="filter-sub-category"><SelectValue placeholder="All Items" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All {SUB_CAT_PLURAL[filters.category] || 'Items'}</SelectItem>
            {filterSubCats.map(sc => <SelectItem key={sc._id} value={sc.name}>{sc.name}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      <Select value={filters.payment_mode} onValueChange={v => setFilters(f => ({ ...f, payment_mode: v === 'all' ? '' : v }))}>
        <SelectTrigger className="w-[120px] h-8 text-xs" data-testid="filter-mode"><SelectValue placeholder="All Modes" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Modes</SelectItem>
          {PAYMENT_MODES.map(m => <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={filters.is_transfer} onValueChange={v => setFilters(f => ({ ...f, is_transfer: v === 'all' ? '' : v }))}>
        <SelectTrigger className="w-[140px] h-8 text-xs" data-testid="filter-transfer"><SelectValue placeholder="All Entries" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Entries</SelectItem>
          <SelectItem value="true">Transfers Only</SelectItem>
          <SelectItem value="false">Regular Only</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
